import { ResponseHelper } from '../_helpers/response.helper'
import axiosInstance from './axios.service'

export class CallsService {
  private setError: (message: string | null) => void

  constructor(setError: (message: string | null) => void) {
    this.setError = setError
  }

  async searchCalls(
    page: number,

  ) {
    return axiosInstance
      .get('/calls/search', {
        params: {
          page,
        }
      })
      .then(res => res.data.data)
      .catch(e => ResponseHelper.handleError(e, this.setError))
  }



}
